import React from "react";
import { Container, Grid, Card, CardContent, Typography, TextField, Button, Box } from "@mui/material";

export default function Contacts() {
  return (
    <Container sx={{ marginTop: 4 }}>
      <Typography variant="h4" gutterBottom align="center">
        Контакты
      </Typography>
      <Grid container spacing={4}>
        {/* Contact Information Section */}
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Контактная информация
              </Typography>
              <Typography variant="body1" paragraph>
                Адрес: ул. Примерная, 123, Город, Страна
              </Typography>
              <Typography variant="body1" paragraph>
                Телефон: +7 (123) 456-7890
              </Typography>
              <Typography variant="body1" paragraph>
                Email: info@college.kz
              </Typography>
              <Typography variant="body1" paragraph>
                Режим работы: Пн-Пт, 9:00 - 18:00
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Feedback Form Section */}
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Обратная связь
              </Typography>
              <Box component="form">
                <TextField
                  fullWidth
                  label="Ваше имя"
                  variant="outlined"
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="Ваш email"
                  variant="outlined"
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="Сообщение"
                  variant="outlined"
                  margin="normal"
                  multiline
                  rows={4}
                />
                <Button variant="contained" color="primary" fullWidth sx={{ marginTop: 2 }}>
                  Отправить сообщение
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Map Section */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom align="center">
            Наше местоположение
          </Typography>
          <Box
            sx={{
              height: "400px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              overflow: "hidden",
            }}>
            <iframe
              title="college-location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509006!2d144.9537363156157!3d-37.81627974202142!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf577d7a3adf1e7e4!2sFederation%20Square!5e0!3m2!1sen!2sau!4v1637752332119!5m2!1sen!2sau"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
